import { DataSheetPreview } from 'features/data-sheet';
import { CONTACT_PROFILE_CONFIG, CONTACT_TAB_IDS } from 'features/inventory-profiles/constants';
import { getCommonTabs } from 'features/inventory-profiles/utils';
import strings from 'strings';
import ContactOverview from 'UI/components/organisms/inventoryProfiles/ContactOverview';
import { TasksTab } from 'UI/components/organisms/inventoryProfiles/TasksTab';

import { CONTACT_TABS_CONFIG } from './ContactProfileV2.constants';
import { getContactAllowedTaskTypes } from './ContactProfileV2.utils';

const COPIES = strings.inventoryProfiles;

/**
 * Tabs of the Contact profile.
 * @param {Object} params
 * @param {Object} params.contact Contact profile
 * @param {string} params.contactName Contact full name
 * @param {boolean} params.isLoading The profile is loading
 * @param {Object} params.permissions Result of useContactPermissions
 * @param {() => void} params.refresh Reloads the profile silently
 * @param {{ id: string, tabProps: Object }} params.searchProjectsTab `searchProjectTabPropsDefinition` of useSearchProjectInProfiles
 * @returns {Array<{ id: string, label: string, content: React.ReactNode, visible: boolean }>}
 */
export const buildContactTabs = ({
  contact,
  contactName,
  isLoading,
  permissions,
  refresh,
  searchProjectsTab
}) => {
  const { [CONTACT_TAB_IDS.ActionPlan]: actionPlan, [CONTACT_TAB_IDS.DataSheet]: dataSheet } =
    CONTACT_TABS_CONFIG;

  return [
    {
      id: CONTACT_TAB_IDS.Overview,
      label: COPIES.common.tabs.overview,
      visible: true,
      content: <ContactOverview loading={isLoading} profile={contact} />
    },
    {
      id: CONTACT_TAB_IDS.ActionPlan,
      label: COPIES.sections.tabs.actionPlan.tabLabel,
      visible: permissions.canUseDailyPlan,
      content: (
        <TasksTab
          allowedTaskTypes={getContactAllowedTaskTypes(contact.status?.id)}
          DataTableProps={actionPlan.DataTableProps}
          entityType={actionPlan.entityType}
          entityTypeId={actionPlan.entityTypeId}
          extraRenderers={actionPlan.extraRenderers}
          initialColumns={actionPlan.initialColumns}
          itemName={contactName}
          profileId={contact.id}
          tablePreferencesKey={actionPlan.tablePreferencesKey}
        />
      )
    },
    {
      id: CONTACT_TAB_IDS.DataSheet,
      label: COPIES.sections.tabs.dataSheet.tabLabel,
      visible: permissions.canSeeDataSheet,
      content: (
        <DataSheetPreview
          apiInstance={dataSheet.apiInstance}
          endpoint={dataSheet.endpoint}
          entityType={dataSheet.entityType}
          formatResponse={dataSheet.formatResponse}
          profileId={contact.id}
        />
      )
    },
    ...getCommonTabs({
      profileId: contact.id,
      entity: CONTACT_PROFILE_CONFIG,
      itemName: contactName,
      onActivityComplete: refresh,
      searchProjectsTab
    })
  ];
};
